/* Blog article image carousel — progressive enhancement.
   Adds prev/next arrows + dots to every [data-awo-article-carousel] on the page.
   No-ops when there's fewer than two slides. Pure CSS scroll-snap already gives
   a swipeable gallery without this file; this only layers on controls. */
(function () {
  function enhance(root) {
    if (root.dataset.awoCarouselReady) return; // idempotent
    var track = root.querySelector('.awo-article-carousel__track');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('.awo-article-carousel__slide')
    );
    if (!track || slides.length < 2) return;
    root.dataset.awoCarouselReady = '1';

    var mk = function (cls, html, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.innerHTML = html;
      b.setAttribute('aria-label', label);
      return b;
    };

    var prev = mk(
      'awo-article-carousel__btn awo-article-carousel__btn--prev',
      '‹',
      'Previous image'
    );
    var next = mk(
      'awo-article-carousel__btn awo-article-carousel__btn--next',
      '›',
      'Next image'
    );

    var dots = document.createElement('div');
    dots.className = 'awo-article-carousel__dots';
    slides.forEach(function (slide, i) {
      var d = mk('awo-article-carousel__dot', '', 'Go to image ' + (i + 1));
      d.addEventListener('click', function () {
        slide.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        });
      });
      dots.appendChild(d);
    });

    root.appendChild(prev);
    root.appendChild(next);
    root.appendChild(dots);

    var step = function (dir) {
      var w = slides[0].getBoundingClientRect().width + 12; // slide + gap
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    prev.addEventListener('click', function () {
      step(-1);
    });
    next.addEventListener('click', function () {
      step(1);
    });

    var dotEls = dots.querySelectorAll('.awo-article-carousel__dot');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var i = slides.indexOf(e.target);
            for (var di = 0; di < dotEls.length; di++) {
              dotEls[di].setAttribute('aria-current', di === i ? 'true' : 'false');
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (s) {
        io.observe(s);
      });
    }
  }

  function init() {
    document
      .querySelectorAll('[data-awo-article-carousel]')
      .forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
